<template>
  <span
    class="icon"
    :class="iconClass"
    :style="iconStyle"
    v-html="svgMarkup"
    aria-hidden="true" />
</template>

<script>
import { getIcon } from '@/assets/icons/index.js'

export default {
  name: 'Icon',
  props: {
    name: {
      type: String,
      required: true
    },
    size: {
      type: Number,
      default: 24
    },
    iconClass: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  },
  computed: {
    svgMarkup () {
      return getIcon(this.name)
    },
    iconStyle () {
      const style = {
        width: `${this.size}px`,
        height: `${this.size}px`
      }
      if (this.color) {
        style.color = this.color
      }
      return style
    }
  }
}
</script>

<style scoped>
.icon {
  display: inline-flex;
  flex-shrink: 0;
}

.icon >>> svg {
  width: 100%;
  height: 100%;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/Common/Icon.vue